/**
 * Full field registry for Kizen contracting-request object.
 *
 * Source: GET /api/records/{objectId}/fields
 * Object: KIZEN_CONTRACTING_REQUEST_OBJECT_ID
 */
/** Machine `name` (snake_case) → field metadata from Kizen `/fields` API. */
export const KIZEN_CONTRACTING_REQUEST_FIELD_BY_NAME = {
    valid_direct_upline_for_carrier: {
        id: "7644f341-427b-4ce6-bd86-b7335db5d37a",
        name: "valid_direct_upline_for_carrier",
        displayName: "Valid Direct Upline for Carrier",
        fieldType: "relationship",
    },
    stage: {
        id: "c614f811-7bc2-4e5a-b46f-bdf461e64317",
        name: "stage",
        displayName: "Stage",
        fieldType: "dropdown",
    },
    email_config_contracting_link: {
        id: "67b7499e-a345-4045-8ada-856c71896493",
        name: "email_config_contracting_link",
        displayName: "Email Config - Contracting Link",
        fieldType: "text",
    },
    latest_request_status: {
        id: "d8713476-2b04-49cd-ab80-191292365d00",
        name: "latest_request_status",
        displayName: "Latest Request Status",
        fieldType: "dropdown",
    },
    name: {
        id: "3ea79917-3dd0-4119-8e66-d14dc79b543a",
        name: "name",
        displayName: "Contracting Request Name",
        fieldType: "text",
    },
    resend_link: {
        id: "5c11c8c2-6a66-429e-8d3a-430e917e207c",
        name: "resend_link",
        displayName: "Resend Link",
        fieldType: "checkbox",
    },
    can_agent_be_contacted: {
        id: "50b0ba50-fc10-455e-adb0-775cf4eabd61",
        name: "can_agent_be_contacted",
        displayName: "Can Agent be Contacted?",
        fieldType: "yesnomaybe",
    },
    created_contract: {
        id: "12d1bd98-7c20-40b3-86ef-872664d48942",
        name: "created_contract",
        displayName: "Created Contract",
        fieldType: "relationship",
    },
    type_of_request: {
        id: "442c0ed6-54ba-485e-90e8-9045ae0697cd",
        name: "type_of_request",
        displayName: "Type Of Request",
        fieldType: "dropdown",
    },
    cancel_request: {
        id: "82872931-dcef-4c35-8e35-de6340228f6e",
        name: "cancel_request",
        displayName: "Cancel Request",
        fieldType: "dropdown",
    },
    contracting_request_status: {
        id: "eaacfbe8-0abf-4a17-919e-6cf3175287dd",
        name: "contracting_request_status",
        displayName: "Contracting Request Status",
        fieldType: "dropdown",
    },
    direct_upline: {
        id: "9a6295de-b266-4500-ab1f-ced91c3e9271",
        name: "direct_upline",
        displayName: "Requested Direct Upline",
        fieldType: "relationship",
    },
    email_config_contracting_text: {
        id: "cb6556f3-f613-4241-8c5a-a0ad61ef50ab",
        name: "email_config_contracting_text",
        displayName: "Email Config - Contracting Text",
        fieldType: "longtext",
    },
    agent_legal_name: {
        id: "bc634dc6-3f91-4c0b-8e02-8168bf985b8b",
        name: "agent_legal_name",
        displayName: "Agent Legal Name",
        fieldType: "text",
    },
    valid_direct_upline_for_carrier_npn: {
        id: "322297cc-3934-4631-b739-9e8c364bf63e",
        name: "valid_direct_upline_for_carrier_npn",
        displayName: "Valid Direct Upline for Carrier NPN",
        fieldType: "text",
    },
    latest_request_sub_status: {
        id: "a1ab5833-b0d1-40cc-9021-22867b4d83af",
        name: "latest_request_sub_status",
        displayName: "Latest Request Sub-Status",
        fieldType: "dropdown",
    },
    agent_or_agency: {
        id: "1d5e78be-a8e1-48a7-a8ed-38019da763ab",
        name: "agent_or_agency",
        displayName: "Agent or Agency?",
        fieldType: "dropdown",
    },
    substituted_agentagency_on_request: {
        id: "391f0be1-868a-4157-bf03-c33fe781bb5c",
        name: "substituted_agentagency_on_request",
        displayName: "Substituted Agent/Agency on Request",
        fieldType: "yesnomaybe",
    },
    linked_contract: {
        id: "dfe9281a-70a1-472a-92bb-40d650495aa7",
        name: "linked_contract",
        displayName: "Linked Contract",
        fieldType: "relationship",
    },
    missing_information: {
        id: "c9f8982c-32ff-4bd1-be3f-96858a3f5228",
        name: "missing_information",
        displayName: "Missing Information",
        fieldType: "dynamictags",
    },
    status_before_hold: {
        id: "8abd84da-5377-4667-8e26-eea384bc3bb3",
        name: "status_before_hold",
        displayName: "Status Before Hold",
        fieldType: "dropdown",
    },
    email_config_contracting_link_loa: {
        id: "fda8a2b0-0143-4f5b-9529-83b3033f0be1",
        name: "email_config_contracting_link_loa",
        displayName: "Email Config - Contracting Link (LOA)",
        fieldType: "text",
    },
    direct_upline_npn: {
        id: "a198815f-d5fd-492d-bccd-25c85afeeda0",
        name: "direct_upline_npn",
        displayName: "Requested Direct Upline NPN",
        fieldType: "text",
    },
    individual_npn: {
        id: "cd59267e-2fe9-4e18-b3df-c106e012a004",
        name: "individual_npn",
        displayName: "Individual NPN",
        fieldType: "text",
    },
    substituted_in_place_of_agentagency: {
        id: "e67cf06f-fcf6-414e-9335-a7fba6066ac2",
        name: "substituted_in_place_of_agentagency",
        displayName: "Substituted In Place of Agent/Agency",
        fieldType: "relationship",
    },
    sub_status_before_hold: {
        id: "c3f4d690-1f15-43bd-8635-6ff165a491e6",
        name: "sub_status_before_hold",
        displayName: "Sub-Status Before Hold",
        fieldType: "dropdown",
    },
    requesting_agentagency: {
        id: "f69088e3-9965-40ad-b244-9cd7af6c8335",
        name: "requesting_agentagency",
        displayName: "Requesting Agent/Agency",
        fieldType: "relationship",
    },
    othermisc_missing_info: {
        id: "9a15698b-e819-48e1-8c9a-840a003d9d0c",
        name: "othermisc_missing_info",
        displayName: "Other/Misc Missing Info",
        fieldType: "text",
    },
    direct_upline_writing_id: {
        id: "f5117363-127b-41e1-9f8d-f1e5cb504dac",
        name: "direct_upline_writing_id",
        displayName: "Requested Direct Upline Writing ID",
        fieldType: "text",
    },
    email_config_contracting_text_loa: {
        id: "d2d67374-3701-42dc-8806-33fecbb4bbe3",
        name: "email_config_contracting_text_loa",
        displayName: "Email Config - Contracting Text (LOA)",
        fieldType: "longtext",
    },
    agency_legal_name: {
        id: "944a7135-94b5-4806-aab2-74bf02fb4fd3",
        name: "agency_legal_name",
        displayName: "Agency Legal Name",
        fieldType: "text",
    },
    additional_note_from_touchpoint: {
        id: "650c5957-c349-4ba7-8867-8457d5bff8b4",
        name: "additional_note_from_touchpoint",
        displayName: "Additional Note from Touchpoint",
        fieldType: "longtext",
    },
    pending_completion_of_upline_contracting: {
        id: "d531ba8f-922b-47f3-9882-bf840aec4a02",
        name: "pending_completion_of_upline_contracting",
        displayName: "Pending Completion of Upline Contracting",
        fieldType: "relationship",
    },
    email_config_agentagency_portal_link: {
        id: "b154251c-6686-4db0-b388-e5c23a364884",
        name: "email_config_agentagency_portal_link",
        displayName: "Email Config - Agent/Agency Portal Link",
        fieldType: "text",
    },
    corp_npn: {
        id: "079dddd1-7eb8-4824-acad-ac84e2d90a88",
        name: "corp_npn",
        displayName: "Corp NPN",
        fieldType: "text",
    },
    status_before_processing_issue: {
        id: "c9c6fc34-8078-4b2d-bcc6-053fefafb63e",
        name: "status_before_processing_issue",
        displayName: "Status Before Processing Issue",
        fieldType: "dropdown",
    },
    requested_commission_advancing: {
        id: "04d33fa1-94a6-4d23-82e7-7b98941087c4",
        name: "requested_commission_advancing",
        displayName: "Requested Commission Advancing",
        fieldType: "relationship",
    },
    requesting_agentagency_npn: {
        id: "6f80a162-91b0-4386-95fa-637e3a0e2327",
        name: "requesting_agentagency_npn",
        displayName: "Requesting Agent/Agency NPN",
        fieldType: "text",
    },
    sub_status_before_processing_issue: {
        id: "c633e4c4-4470-4e8b-b64e-1fe0d8b44b7e",
        name: "sub_status_before_processing_issue",
        displayName: "Sub-Status Before Processing Issue",
        fieldType: "dropdown",
    },
    pending_downline_contracting_requests: {
        id: "97343d34-604f-47ef-9fd7-1e7b0e2860a6",
        name: "pending_downline_contracting_requests",
        displayName: "Pending Downline Contracting Requests",
        fieldType: "relationship",
    },
    agent_ssn: {
        id: "c8e91598-4890-45a7-88a0-345f9d2158aa",
        name: "agent_ssn",
        displayName: "Agent SSN",
        fieldType: "text",
    },
    require_intent_to_move_or_release: {
        id: "2208cfb5-e106-4f5b-86fc-b31693915b87",
        name: "require_intent_to_move_or_release",
        displayName: "Is a Release or Intent to Move required?",
        fieldType: "dropdown",
    },
    in_house_business: {
        id: "3f5565b9-9084-4e13-9bd0-b18ebf20a440",
        name: "in_house_business",
        displayName: "In-House Business?",
        fieldType: "yesnomaybe",
    },
    new_request_type_toggle: {
        id: "b2bae378-42ba-42f2-8e13-57732daa6497",
        name: "new_request_type_toggle",
        displayName: "New Request Type Toggle",
        fieldType: "checkbox",
    },
    email_config_add_states_carrier_contact_name: {
        id: "be2bdc60-dd37-4876-bee2-0f177e7c30f7",
        name: "email_config_add_states_carrier_contact_name",
        displayName: "Email Config - Carrier Add States Contact Name",
        fieldType: "text",
    },
    requested_carrier_contract_unique_id: {
        id: "9e4512ed-a4e0-401f-a230-3a03ceb905ce",
        name: "requested_carrier_contract_unique_id",
        displayName: "Requested Carrier-Contract (Unique ID)",
        fieldType: "relationship",
    },
    agency_tin: {
        id: "b06015f3-4ee5-4317-9b99-0e72b2e27884",
        name: "agency_tin",
        displayName: "Agency TIN",
        fieldType: "text",
    },
    top_line_carrier: {
        id: "f04f0523-28e0-4a8f-9726-a798e4abba0a",
        name: "top_line_carrier",
        displayName: "Top-Line Carrier",
        fieldType: "relationship",
    },
    agent_dob: {
        id: "f41243bc-a833-44af-9ff2-3cafa84badee",
        name: "agent_dob",
        displayName: "Agent DOB",
        fieldType: "date",
    },
    itm_evaluation_period_end: {
        id: "c5bf69f1-59c8-4c81-af9b-84d80357c46d",
        name: "itm_evaluation_period_end",
        displayName: "ITM Evaluation Period End:",
        fieldType: "date",
    },
    pending_upline_agent_record: {
        id: "135040cb-3320-4ddf-99e2-81e3884ce76f",
        name: "pending_upline_agent_record",
        displayName: "Pending Upline Agent Record",
        fieldType: "relationship",
    },
    on_hold_until_date: {
        id: "19c96f2b-37ea-4abc-9c99-c429fc10068b",
        name: "on_hold_until_date",
        displayName: "On Hold Until (Date)",
        fieldType: "date",
    },
    line_of_business: {
        id: "f1da2126-954b-41c4-989a-cc763f56d019",
        name: "line_of_business",
        displayName: "Line of Business",
        fieldType: "dropdown",
    },
    days_of_inactivity: {
        id: "54215cc3-5643-47ef-8c98-af71e62f36f1",
        name: "days_of_inactivity",
        displayName: "# Days of Inactivity",
        fieldType: "integer",
    },
    writing_id: {
        id: "59f4fb29-6023-4acc-8a54-bcb9ce75f001",
        name: "writing_id",
        displayName: "Requesting Agent/Agency Writing ID",
        fieldType: "text",
    },
    email_config_carrier_general_contracting_contact_name: {
        id: "b908bb22-1056-497c-b522-5014bd20fb04",
        name: "email_config_carrier_general_contracting_contact_name",
        displayName: "Email Config - Carrier General Contracting Contact Name",
        fieldType: "text",
    },
    email_config_agentagency: {
        id: "51716b1b-5021-4fcc-9bdb-e76a88d83030",
        name: "email_config_agentagency",
        displayName: "Email Config - Agent/Agency",
        fieldType: "dropdown",
    },
    disallowed_selection_on_previous_action: {
        id: "301ac3e5-648d-45ad-82cf-8525fc2e5d20",
        name: "disallowed_selection_on_previous_action",
        displayName: "Disallowed Selection on Previous Action",
        fieldType: "checkbox",
    },
    paper_contract: {
        id: "af5c759b-f0a9-424e-964c-f3b54f6cae71",
        name: "paper_contract",
        displayName: "Paper Contract",
        fieldType: "files",
    },
    agent_level: {
        id: "99abfd5d-0f3d-42ba-bcac-c1b9ffb6be72",
        name: "agent_level",
        displayName: "Requested Agent Level",
        fieldType: "relationship",
    },
    other_related_agentsagencies: {
        id: "06ce2101-6c3d-4b29-b151-dcfedfa6ab5a",
        name: "other_related_agentsagencies",
        displayName: "Other Related Agents/Agencies",
        fieldType: "relationship",
    },
    current_agentagency_level_for_carrier: {
        id: "bdec55ae-1993-4b42-9434-5b64addec29b",
        name: "current_agentagency_level_for_carrier",
        displayName: "Current Agent/Agency Level for Carrier (Change Level Requests)",
        fieldType: "relationship",
    },
    current_direct_upline: {
        id: "c7464562-554a-4486-96d3-bba60bfcfdfa",
        name: "current_direct_upline",
        displayName: "Current Direct Upline (Change Hierarchy Requests)",
        fieldType: "relationship",
    },
    moving_to_or_from_loa: {
        id: "670e81e8-a3b3-4a05-bace-df9008974249",
        name: "moving_to_or_from_loa",
        displayName: "Moving To or From LOA (Change Level Requests)",
        fieldType: "checkbox",
    },
    latest_reason_selection_was_disallowed: {
        id: "e505a8f3-1711-429b-812a-38b912eb6770",
        name: "latest_reason_selection_was_disallowed",
        displayName: "Latest Reason Selection was Disallowed",
        fieldType: "longtext",
    },
    transfer_release: {
        id: "0ee701c2-f782-4e76-8a38-0369f324894e",
        name: "transfer_release",
        displayName: "Transfer Release/Intent to Move Doc",
        fieldType: "files",
    },
    modification_request_payable_entity_with_carrier_for_contract: {
        id: "1cde458d-6788-4e8c-8abc-0aa43858e375",
        name: "modification_request_payable_entity_with_carrier_for_contract",
        displayName: "Modification Request - Payable Entity with Carrier for Contract",
        fieldType: "relationship",
    },
    modification_request_commission_advancing_for_contract: {
        id: "f01e5da3-7742-4315-a4ec-23b51bde79d5",
        name: "modification_request_commission_advancing_for_contract",
        displayName: "Modification Request - Commission Advancing for Contract",
        fieldType: "relationship",
    },
    follow_up_count_link_contracting: {
        id: "100ee281-7e95-4fa9-a3ca-1eb6c5043c95",
        name: "follow_up_count_link_contracting",
        displayName: "Follow Up Count (Link) - Contracting",
        fieldType: "integer",
    },
    states: {
        id: "b8161fdc-32f0-4e1a-9128-589b7f04d7aa",
        name: "states",
        displayName: "States",
        fieldType: "relationship",
    },
    modification_request_jit_activation_workflow_for_contract: {
        id: "c27bb7fd-7a97-4f7e-85c4-cb0e3f5502dc",
        name: "modification_request_jit_activation_workflow_for_contract",
        displayName: "Modification Request - JIT Activation Workflow for Contract",
        fieldType: "relationship",
    },
    follow_up_count_link_sales: {
        id: "10eab69e-debc-4a7f-bf0e-822db092beae",
        name: "follow_up_count_link_sales",
        displayName: "Follow Up Count (Link) - Sales",
        fieldType: "integer",
    },
    original_request_agentagency: {
        id: "3481c7f5-60c9-4b50-a41e-7f1fba6e4cb9",
        name: "original_request_agentagency",
        displayName: "Original Request - Agent/Agency",
        fieldType: "relationship",
    },
    link_sent_by: {
        id: "97f1979c-44a5-4646-b3aa-584fcef6a14d",
        name: "link_sent_by",
        displayName: "Link Sent By",
        fieldType: "dropdown",
    },
    original_request_fallback_agentagency: {
        id: "f87fd999-4e6e-487b-91a8-399cfc613cdf",
        name: "original_request_fallback_agentagency",
        displayName: "Original Request - Fallback Agent/Agency",
        fieldType: "relationship",
    },
    follow_up_count_link_support: {
        id: "e5f7015c-5035-4569-acc7-60482bf98012",
        name: "follow_up_count_link_support",
        displayName: "Follow Up Count (Link) - Support",
        fieldType: "integer",
    },
    follow_up_link_current_position: {
        id: "52e96faa-e0c0-445a-9801-786ae6901b6a",
        name: "follow_up_link_current_position",
        displayName: "Follow Up (Link) - Current Position",
        fieldType: "dropdown",
    },
    existing_agent_level: {
        id: "768a6c00-8c15-4491-8b89-4eea6eed8f2d",
        name: "existing_agent_level",
        displayName: "Existing Agent Level (Change Level Requests)",
        fieldType: "dynamictags",
    },
    follow_up_link_next_custom_date: {
        id: "71e44257-9020-48c9-989d-5917250d77c8",
        name: "follow_up_link_next_custom_date",
        displayName: "Follow Up (Link) - Next Custom Date",
        fieldType: "date",
    },
    created_due_to_upline_change: {
        id: "213968a4-7988-4075-a3c7-20b50dc44b8e",
        name: "created_due_to_upline_change",
        displayName: "Created Due to Upline Hierarchy Change",
        fieldType: "dropdown",
    },
    follow_up_count_certs_contracting: {
        id: "013b5542-d1e7-4574-bc11-60b77e8cf6db",
        name: "follow_up_count_certs_contracting",
        displayName: "Follow Up Count (Certs) - Contracting",
        fieldType: "integer",
    },
    downlines_moving_to_a_different_upline: {
        id: "cfad05a1-8aed-447f-ab6b-b5c9e9eff925",
        name: "downlines_moving_to_a_different_upline",
        displayName: "Downlines Moving to a Different Upline",
        fieldType: "dropdown",
    },
    follow_up_count_certs_sales: {
        id: "6730be1d-4df1-4433-b8b8-0034a79a2aef",
        name: "follow_up_count_certs_sales",
        displayName: "Follow Up Count (Certs) - Sales",
        fieldType: "integer",
    },
    conditional_on_multiple_principals_selected_principal: {
        id: "d09ad62d-5679-4c75-baf9-0249b7f8e67f",
        name: "conditional_on_multiple_principals_selected_principal",
        displayName: "(Conditional on Multiple Principals) - Selected Principal",
        fieldType: "relationship",
    },
    follow_up_count_certs_support: {
        id: "ea0c1185-6609-4604-a3bd-dc95589642d2",
        name: "follow_up_count_certs_support",
        displayName: "Follow Up Count (Certs) - Support",
        fieldType: "integer",
    },
    follow_up_certs_current_position: {
        id: "acfbb4f9-5ddf-48c6-986f-8ffc4994f50a",
        name: "follow_up_certs_current_position",
        displayName: "Follow Up (Certs) - Current Position",
        fieldType: "dropdown",
    },
    display_name: {
        id: "aef66827-da6e-48cf-b144-42b58cedddbd",
        name: "display_name",
        displayName: "Display Name",
        fieldType: "text",
    },
    payable_entity_name_conditional: {
        id: "fd0c61c0-b5a0-4344-8fd5-3dc2d0fb80d7",
        name: "payable_entity_name_conditional",
        displayName: "Payable Entity Name (Conditional)",
        fieldType: "relationship",
    },
    follow_up_certs_next_custom_date: {
        id: "95dfca42-31f6-4d67-b9b8-54c5fb3160f5",
        name: "follow_up_certs_next_custom_date",
        displayName: "Follow Up (Certs) - Next Custom Date",
        fieldType: "date",
    },
    recruiting_capable: {
        id: "955bf063-ab45-4e67-bcc3-37a974829fe9",
        name: "recruiting_capable",
        displayName: "Recruiting Capable",
        fieldType: "checkbox",
    },
    releaseintent_file_uploaded_and_waiting_on_verification: {
        id: "78e4378e-1991-4105-8015-288c7815ee6c",
        name: "releaseintent_file_uploaded_and_waiting_on_verification",
        displayName: "Release/Intent - File Uploaded and Waiting on Verification",
        fieldType: "checkbox",
    },
    releaseintentmissing_info_who_is_following_up_on_this: {
        id: "7c8fb40c-5cf5-475f-b0e9-c7d14c10973f",
        name: "releaseintentmissing_info_who_is_following_up_on_this",
        displayName: "Release/Intent/Missing Info - Who is Following Up On This?",
        fieldType: "dropdown",
    },
    releaseintentmissing_info_latest_request_type: {
        id: "3463cdf6-7e25-4ddd-b6ba-71d17a541a76",
        name: "releaseintentmissing_info_latest_request_type",
        displayName: "Release/Intent/Missing Info - Latest Information Request Type",
        fieldType: "dropdown",
    },
    contracting_request_has_invalid_selection_for: {
        id: "956fe564-942d-48bb-b706-a1e57f655396",
        name: "contracting_request_has_invalid_selection_for",
        displayName: "Contracting Request Has Invalid Selection For",
        fieldType: "dropdown",
    },
    other_missing_information_comma_delimited: {
        id: "06093b32-fc96-41a3-8273-1d8f6273392d",
        name: "other_missing_information_comma_delimited",
        displayName: "Other Missing Information (Comma-Delimited)",
        fieldType: "text",
    },
    missing_information_uploads: {
        id: "c49e5109-a7ea-477b-b293-0bf819f20cd7",
        name: "missing_information_uploads",
        displayName: "Missing Information Uploads",
        fieldType: "files",
    },
    waiting_on_upline_contract_request: {
        id: "0fd09246-bdac-4df3-aaca-4f48e2190766",
        name: "waiting_on_upline_contract_request",
        displayName: "Waiting on Upline Contract Request",
        fieldType: "relationship",
    },
    when_activated_triggers_re_activation_of_requests: {
        id: "64526c91-1a9c-46c3-a622-91bfa9ed6177",
        name: "when_activated_triggers_re_activation_of_requests",
        displayName: "When Activated > Triggers Re-Activation of Requests",
        fieldType: "relationship",
    },
    date_of_upline_hold: {
        id: "88fd6017-4f2f-445d-9380-d59e35c0bd10",
        name: "date_of_upline_hold",
        displayName: "Date of Upline Contracting Hold",
        fieldType: "date",
    },
    cancel_request_quick_action: {
        id: "9820dd7c-f6be-4697-8f0b-d51b936546ee",
        name: "cancel_request_quick_action",
        displayName: "Cancel Request - Quick Action",
        fieldType: "dropdown",
    },
    type_of_email_request: {
        id: "6058eaa1-e24f-4168-8f3c-1f660c3d06a8",
        name: "type_of_email_request",
        displayName: "Type of Email Request",
        fieldType: "text",
    },
    termination_requested_date: {
        id: "32cf5420-ffad-4958-b377-1530455670ba",
        name: "termination_requested_date",
        displayName: "Termination - Requested Date",
        fieldType: "date",
    },
    termination_documents: {
        id: "ad606dc0-e69d-4171-a747-28912adf9ce5",
        name: "termination_documents",
        displayName: "Termination - Documents",
        fieldType: "files",
    },
    termination_reason: {
        id: "c2199ab9-e55f-4201-b486-11b7f803cdb7",
        name: "termination_reason",
        displayName: "Termination - Reason",
        fieldType: "dropdown",
    },
    termination_successfully_scheduled: {
        id: "69d7904b-648f-4443-87b3-3b5ebf0572a9",
        name: "termination_successfully_scheduled",
        displayName: "Termination - Successfully Scheduled",
        fieldType: "yesnomaybe",
    },
    follow_up_dnc_skip_occurred: {
        id: "29e62f54-093f-4320-b3e5-daa8fdd60c4b",
        name: "follow_up_dnc_skip_occurred",
        displayName: "Follow Up - DNC Skip Occurred",
        fieldType: "yesnomaybe",
    },
    link_check_request_count: {
        id: "e8c01469-8d7c-44d4-a97a-12e1aadf96a6",
        name: "link_check_request_count",
        displayName: "Link - Check Request Count",
        fieldType: "integer",
    },
    certs_check_request_count: {
        id: "1f7064c4-357e-4cf4-a2f2-5e1ca37e7561",
        name: "certs_check_request_count",
        displayName: "Certs - Check Request Count",
        fieldType: "integer",
    },
    request_contracting_resend_link: {
        id: "90132fee-00ec-44e8-93fa-3b0b844e631a",
        name: "request_contracting_resend_link",
        displayName: "Request Contracting Resend Link",
        fieldType: "checkbox",
    },
};
